import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Set mobile browser chrome to brand black immediately
const setThemeColor = () => {
  let meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  meta.content = '#0a0a0a';
};
setThemeColor();
// Force background to brand black before React renders to eliminate white flash
document.documentElement.style.backgroundColor = '#0a0a0a';
document.body.style.backgroundColor = '#0a0a0a';
ReactDOM.createRoot(document.getElementById('root')!).render(<App data-id="element-391" />);